<mc-header></mc-header>
@if (notificationsDrawer.opened | async) {
  <ng-container *permissionGuard="UserPermissions.notifications.drawer">
    <mc-notifications-drawer></mc-notifications-drawer>
  </ng-container>
}
<mat-drawer-container class="main-container">
  <mat-drawer #sidenav mode="side" [opened]="sideNavOpened" class="main-drawer" [ngClass]="{hidden: !sidenav.opened}">
    <button
      aria-label="Sidebar navigation"
      [attr.aria-expanded]="sidenav.opened ? 'true' : 'false'"
      type="button"
      class="main-drawer__toggle"
      [ngClass]="sidenav.opened ? '' : 'side-bar-hidden'"
      (click)="onToggleClick()"
      data-testid="navigation.expand-button"
    >
      <mat-icon svgIcon="arrow-blue" class="main-drawer__toggle_icon"></mat-icon>
    </button>
    <mc-navigation [isSidenavOpened]="sidenav.opened"></mc-navigation>
  </mat-drawer>
  <mat-drawer-content tabindex="-1" class="main-drawer-content" [ngClass]="{regulationLawsView: isRegulationLawsView}">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
